import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Profile from 'src/models/Profile';
import GeneratorEntity from '../../../../../models/Generator';
import translations from '../../translations';
import TableRow from './TableRow';

interface IProps {
  generators: GeneratorEntity[]

  delete: (generator: GeneratorEntity) => void
  validator: (generator: GeneratorEntity) => void
  run: (generator: GeneratorEntity) => void
  openTokenModalForGenerator: (gen: GeneratorEntity) => void;


  profile: Profile
}

export const ListView: React.SFC<IProps> = props => {
  return (
    <table className="table is-hoverable is-fullwidth">
        <thead>
            <tr>
              <th className="is-narrow"><span className="icon"><i className="fal fa-images"/></span></th>
              <th><FormattedMessage {...translations.lwname} /></th>
              <th><FormattedMessage {...translations.lwdescription} /></th>
              <th><FormattedMessage {...translations.lwcategories} /></th>
              <th><FormattedMessage {...translations.lwactions} /></th>
            </tr>
        </thead>
        <tbody>
            {props.generators.map( gen => {
              return <TableRow generator={gen}  key={gen.id} delete={props.delete} run={props.run} profile={props.profile} openTokenModalForGenerator={props.openTokenModalForGenerator}/>
            })}
        </tbody>
    </table>
  )
};



// WEBPACK FOOTER //
// ./src/Containers/generators/GeneratorList/GeneratorView/ListView/index.tsx